import axios from 'axios';
// import ElementUI from 'element-ui';

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BACK_END_URL}/api/v1`
});

instance.interceptors.request.use(config => {
  if (localStorage.getItem("token") != undefined) {
    config.headers['Authorization'] = 'JWT ' + localStorage.getItem("token");
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

instance.interceptors.response.use((res) => {
  return res.data;
},
  err => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('vuex');
      localStorage.removeItem('token');
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
    }
    return err.response && err.response.data ? err.response.data : err.response;
  }
);

export default instance;
